import { PageHeader } from '../../components/layout/AppLayout'
import { Button } from '../../components/ui/Button'
import { Callout } from '../../components/ui/Callout'
import { Card, CardBody, CardHeader, EmptyState } from '../../components/ui/Card'
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen'
import { usePublicConfig } from '../../lib/session'

export function ServiceAreas() {
  const isSmallScreen = useIsSmallScreen()
  const { data: config } = usePublicConfig()
  const hasMapsKey = Boolean(config?.mapsApiKey)

  return (
    <>
      <PageHeader
        title="Service areas"
        description="Outline the neighborhoods your unit can serve. Customers outside every area cannot sign up."
        action={
          <Button disabled={isSmallScreen} title={isSmallScreen ? 'Drawing needs a larger screen' : undefined}>
            Draw a new area
          </Button>
        }
      />

      <div className="space-y-5">
        {/* Drawing a polygon means placing vertices precisely and dragging them to adjust,
            which is genuinely awkward on a touch screen. Say so up front rather than
            letting a Unit Admin fight with it. */}
        {isSmallScreen && (
          <Callout title="Best drawn on a desktop browser" tone="warning">
            <p>
              Drawing a service area needs a larger screen to place and adjust the boundary
              accurately. You can review existing areas here, but come back on a desktop or
              laptop browser to draw or edit one.
            </p>
          </Callout>
        )}

        {!hasMapsKey && (
          <Callout title="Map not configured">
            <p>
              The Google Maps browser key is not set for this environment, so the map cannot
              load. Set <code className="font-mono text-xs">Google:MapsBrowserApiKey</code> and
              reload.
            </p>
          </Callout>
        )}

        <Card>
          <CardHeader
            title="Your areas"
            description="A closed shape on the map. Areas may overlap or sit apart from each other."
          />
          <EmptyState
            title="No service areas yet"
            description="Until you draw at least one area, no customer can complete a signup with your unit."
            action={<Button disabled={isSmallScreen}>Draw your first area</Button>}
          />
        </Card>

        <Card>
          <CardHeader title="Map" description="Placeholder until the drawing tool is wired up." />
          <CardBody>
            <div className="flex aspect-16/9 items-center justify-center rounded-xl border border-dashed border-[color:var(--surface-border)] bg-[color:var(--surface-sunken)]">
              <p className="px-6 text-center text-sm text-[color:var(--text-muted)]">
                The Google Maps drawing surface goes here. Polygons must be closed, cannot
                cross over themselves, and are validated again on the server before they save.
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  )
}
